if (!window.scriptHasRun) {
    let mainFeatureStash = null;
    const addProductListeners = () => {
        const navMenus = document.querySelectorAll('.product-views-list');
        navMenus.forEach(function(menu) {
            menu.innerHTML = navMenus[0].innerHTML;
        });
        let items = document.querySelectorAll('.product-views-item');
        items.forEach(function(item, index) {
            item.addEventListener('click', function() {
                let category = this.getAttribute('data-category');
                category = category.replace(/-/g, ' ');
                category = category.replace(/\b\w/g, function(l){ return l.toUpperCase() });
                fetchProductsForCategory(index, category);
            });
        });
    }

    document.addEventListener('DOMContentLoaded', addProductListeners);
    document.addEventListener('DOMContentLoaded', function() {
        const sectionsArray = document.getElementsByClassName('shopify-section new-featured-collection');
        if (sectionsArray.length > 0) {
            //stash content of first section
            mainFeatureStash = sectionsArray[0].innerHTML;
            const menuItems = document.querySelectorAll('.product-views-item');
            menuItems[1].classList.add('active-menu-item');
        }
    });

    function fetchProductsForCategory(index) {
        let sectionsArray = document.getElementsByClassName('shopify-section new-featured-collection');
        const mainFeature = sectionsArray[0];

        let targetSectionIndex;
        switch(index) {
            //first menu item corresponds to the second section
            case 0:
                targetSectionIndex = 1;
                break;
            //second menu item corresponds to the first section
            case 1:
                targetSectionIndex = 0;
                break;
            //third menu item corresponds to the third section
            case 2:
                targetSectionIndex = 2;
                break;
            default:
                return;
        }

        if (targetSectionIndex < sectionsArray.length) {
            if (targetSectionIndex === 0) {
                //restore content of first section
                mainFeature.innerHTML = mainFeatureStash;
            } else {
                //swap content for section other than the first
                mainFeature.innerHTML = sectionsArray[targetSectionIndex].innerHTML; 
            }
        }

        updateMenuItems(index);
        //reapply listeners after content change
        addProductListeners();
    }

    function updateMenuItems(activeIndex) {
        const menuItems = document.querySelectorAll('.product-views-item');
        menuItems.forEach(function(item, index) {
            item.classList.toggle('active-menu-item', index === activeIndex);
        });
    }
}